export default {
  body: {
    padding: 25,
  },
  loading: {
    maxWidth: '100px',
    maxHeight: '100px',
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
  },
};



// WEBPACK FOOTER //
// ./src/components/Common/FirebaseCarousel/styles.js